import React from 'react';
import { useProgramsSystemMessage } from '../../hooks/useProgramsSystemMessage';
import { ChatRealmContextProvider } from '../../../growegy-ai/chat/chatRealmContext';
import { CHAT_TYPE_CREATE_PROGRAM } from '../../../growegy-ai/dto';
import { PopupChat } from '../../../commons/components/PopupChat';
import { CalendarWithSolidSpark } from '../../../assets/icons';

export const ProgramsChat = () => {
  const programsSystemMessage = useProgramsSystemMessage();
  return (
    <ChatRealmContextProvider chatType={CHAT_TYPE_CREATE_PROGRAM}>
      <PopupChat
        systemMessage={programsSystemMessage}
        chatType={CHAT_TYPE_CREATE_PROGRAM}
        dataTestPrefix="calendar"
        right={24}
        bottom={24}
        maxWidth={480}
        icon={() => <CalendarWithSolidSpark className="growegy-ai__floating-button-icon" />}
      />
    </ChatRealmContextProvider>
  );
};
